import Badge from "../Badge";

const BooleanBadgeTrue = () => {
  return (
    <Badge
      h="29px"
      w="fit-content"
      lineHeight="29px"
      fontSize="14px"
      fontWeight="500"
      px="12px"
      rounded="xl"
      backgroundColor="green.50"
      color="green.700"
      border={"solid 1px"}
      borderColor="green.200"
      textAlign="center"
    >
      Fait
    </Badge>
  );
};

const BooleanBadgeFalse = () => {
  return (
    <Badge
      h="29px"
      w="fit-content"
      lineHeight="29px"
      fontSize="14px"
      fontWeight="500"
      px="12px"
      rounded="xl"
      backgroundColor="gray.50"
      color="gray.700"
      border={"solid 1px"}
      borderColor="gray.200"
      textAlign="center"
    >
      En attente
    </Badge>
  );
};

const BooleanBadge = ({ value }: { value: boolean }) => {
  if (value === true) {
    return <BooleanBadgeTrue />;
  }
  return <BooleanBadgeFalse />;
};

export default BooleanBadge;
